import { render, staticRenderFns } from "./TablePaginatedNegatives.vue?vue&type=template&id=768e5717&scoped=true"
import script from "./TablePaginatedNegatives.vue?vue&type=script&lang=js"
export * from "./TablePaginatedNegatives.vue?vue&type=script&lang=js"
import style0 from "./TablePaginatedNegatives.vue?vue&type=style&index=0&id=768e5717&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768e5717",
  null
  
)

export default component.exports